
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inflationhedge",
      function () {
        return require("private-next-pages/inflationhedge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inflationhedge"])
      });
    }
  